if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        const body = {};

        formData.forEach(function (value, key) {
          body[key] = value;
        });

        config.body = formData;

        if (body["radio-ramme"] && body["radio-ramme"] !== "noRamme") {
          const cartBody = {
            items: [
              { id: body.id, quantity: 1 },
              { id: body["radio-ramme"], quantity: 1 },
            ],
          };

          config.body = JSON.stringify(cartBody);
          config.headers["Content-Type"] = "application/json";
          config.headers["Accept"] = "application/json";
        }

        console.log("Submission:", config, config.body);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            console.log("Fetch Response:", { body: config.body, response });
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            console.log("ProductForm Submit:", this.cart);

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

window.theme = window.theme || {};

theme.utils = {
  defaultTo: function (value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  },

  prepareTransition: function () {
    return this.each(function () {
      var t = e(this);
      t.one(
        "TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",
        function () {
          t.removeClass("is-transitioning");
        }
      );
      var n = [
          "transition-duration",
          "-moz-transition-duration",
          "-webkit-transition-duration",
          "-o-transition-duration",
        ],
        i = 0;
      e.each(n, function (e, n) {
        i = parseFloat(t.css(n)) || i;
      }),
        0 != i && (t.addClass("is-transitioning"), t[0].offsetWidth);
    });
  },

  wrap: function (el, wrapper) {
    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);
  },

  debounce: function (wait, callback, immediate) {
    var timeout;
    return function () {
      var context = this,
        args = arguments;
      var later = function () {
        timeout = null;
        if (!immediate) callback.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) callback.apply(context, args);
    };
  },

  throttle: function (limit, callback) {
    var waiting = false;
    return function () {
      if (!waiting) {
        callback.apply(this, arguments);
        waiting = true;
        setTimeout(function () {
          waiting = false;
        }, limit);
      }
    };
  },

  prepareTransition: function (el, callback) {
    el.addEventListener("transitionend", removeClass);

    function removeClass(evt) {
      el.classList.remove("is-transitioning");
      el.removeEventListener("transitionend", removeClass);
    }

    el.classList.add("is-transitioning");
    el.offsetWidth; // check offsetWidth to force the style rendering

    if (typeof callback === "function") {
      callback();
    }
  },

  // _.compact from lodash
  // Creates an array with all falsey values removed. The values `false`, `null`,
  // `0`, `""`, `undefined`, and `NaN` are falsey.
  // _.compact([0, 1, false, 2, '', 3]);
  // => [1, 2, 3]
  compact: function (array) {
    var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  serialize: function (form) {
    var arr = [];
    Array.prototype.slice.call(form.elements).forEach(function (field) {
      if (
        !field.name ||
        field.disabled ||
        ["file", "reset", "submit", "button"].indexOf(field.type) > -1
      )
        return;
      if (field.type === "select-multiple") {
        Array.prototype.slice.call(field.options).forEach(function (option) {
          if (!option.selected) return;
          arr.push(
            encodeURIComponent(field.name) +
              "=" +
              encodeURIComponent(option.value)
          );
        });
        return;
      }
      if (["checkbox", "radio"].indexOf(field.type) > -1 && !field.checked)
        return;
      arr.push(
        encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value)
      );
    });
    return arr.join("&");
  },
};

theme.Currency = (function () {
  var moneyFormat = "${{amount}}";
  var superScript = theme && theme.settings && theme.settings.superScriptPrice;

  function formatMoney(cents, format) {
    if (!format) {
      format = "${{amount}}";
    }

    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = theme.utils.defaultTo(precision, 2);
      thousands = theme.utils.defaultTo(thousands, ",");
      decimal = theme.utils.defaultTo(decimal, ".");

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split(".");
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : "";

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);

        if (superScript && value && value.includes(".")) {
          value = value.replace(".", "<sup>") + "</sup>";
        }

        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");

        if (superScript && value && value.includes(",")) {
          value = value.replace(",", "<sup>") + "</sup>";
        }

        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  function getBaseUnit(variant) {
    if (!variant) {
      return;
    }

    if (
      !variant.unit_price_measurement ||
      !variant.unit_price_measurement.reference_value
    ) {
      return;
    }

    return variant.unit_price_measurement.reference_value === 1
      ? variant.unit_price_measurement.reference_unit
      : variant.unit_price_measurement.reference_value +
          variant.unit_price_measurement.reference_unit;
  }

  return {
    formatMoney: formatMoney,
    getBaseUnit: getBaseUnit,
  };
})();

window.Images = {
  removeProtocol(path) {
    return path.replace(/http(s)?:/, "");
  },
  getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === "master") {
      return this.removeProtocol(src);
    }

    const match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match) {
      const prefix = src.split(match[0]);
      const suffix = match[0];

      return this.removeProtocol(`${prefix[0]}_${size}${suffix}`);
    } else {
      return null;
    }
  },
};

// Rammer Adjustments
class RammerOptions extends HTMLElement {
  constructor() {
    super();
    this.el = this;
    this.$container = this.el.querySelector("#rammeOption");
    this.$selection = this.el.querySelector("#rammeSelection");
    this.formId = this.dataset.formId;
    this.$form = document.getElementById(this.formId);

    this.productHandle = this.dataset.productHandle;
    this.moneyFormat = this.el.dataset.moneyFormat;
    this.product = document.querySelector("[data-product-source]")
      ? JSON.parse(document.querySelector("[data-product-source]").innerHTML)
      : null;
    this.products = [];
    console.log(this.productHandle);
    console.log(this.products);

    this.translations = {
      soldout: this.el.dataset.translationsSoldout,
      choose_frame: this.el.dataset.translationsChooseFrame,
      only_poster: this.el.dataset.translationsOnlyPoster,
      poster_no_frame: this.el.dataset.translationsPosterNoFrame,
      frame_in_stock: this.el.dataset.translationsFrameInStock,
    };

    // console.log('Ramme Options!:',{
    //   dataset: this.el.dataset,
    //   handle: this.productHandle,
    //   product: this.product,
    // }, this.translations, this.el.dataset);

    this.assets = {
      only_poster: this.dataset.assetOnlyPoster,
    };

    this.updateSelection = this.updateSelection.bind(this);
    this.frameSelectHandlers = this.frameSelectHandlers.bind(this);
    this.fetchSourceProduct();

    this.$form.addEventListener("submit", this.handleSubmit.bind(this));

    document.addEventListener(
      PUB_SUB_EVENTS.variantChange,
      this.onChangeCallback.bind(this)
    );

    subscribe(PUB_SUB_EVENTS.variantChange, this.onChangeCallback.bind(this));
  }

  async fetchSourceProduct() {
    const url = `/products/${this.productHandle}.js`;
    const product = await fetch(url).then((res) => res.json());

    this.product = product;
    this.setCollection();
  }

  handleSubmit(event) {
    const $checkedInput = this.$container.querySelector("input:checked");

    if ($checkedInput.value === "noRamme") return;

    const items = [
      {
        id: Number($checkedInput.id),
        quantity: 1,
        properties: {},
      },
    ];

    setTimeout(() => {
      theme.AjaxProduct.prototype.addItemFromData({ items }).then(() => {
        const event = new Event("cart:build");
        document.dispatchEvent(event);
      });
    }, 500);
  }

  onChangeCallback(event) {
    this.renderFrames();
  }

  currentRammerSet() {
    const selectedVariant = this.variant();
    const sizeIndex = [...this.product.options].reduce((key, option, index) => {
      return /size/i.test(option.name) ? `option${index + 1}` : key;
    }, null);

    return [...this.products].reduce((products, product) => {
      const variant = [...product.variants].find(
        (variant) => variant[sizeIndex] === selectedVariant[sizeIndex]
      );

      if (!variant) return products;

      const item = {
        ...variant,
        product_featured_image: window.Images.getSizedImageUrl(
          product.featured_image,
          "x150"
        ),
      };

      products.push(item);

      return products;
    }, []);
  }

  variantId() {
    return this.$form.querySelector('[name="id"]').value;
  }

  variant() {
    return [...this.product.variants].find(
      (variant) => variant.id == this.variantId()
    );
  }

  async setCollection() {
    const url = `/collections/frames?view=data`;
    const page = await fetch(url).then((res) => res.json());

    this.products = [...page.products].map((product) => ({
      ...product,
      variants: [...product.variants].map((variant, index) => ({
        ...variant,
        inventory_quantity: page.inventories[product.handle][index],
      })),
    }));

    // console.log('setCollections:', { page });

    // initial render
    this.renderFrames();

    this.$container.addEventListener("change", this.updateSelection);
  }

  updateSelection() {
    const $checkedInput = this.$container.querySelector("input:checked");
    const selection = $checkedInput.value;
    const currentFrames = this.currentRammerSet();

    const variant = [...currentFrames].find(({ id }) => selection == id);

    // console.log('Update Selection', $checkedInput, { currentFrames, variant, selection });
    this.$selection.innerHTML = variant
      ? `<span>${variant.name.split("-")[0]} +${theme.Currency.formatMoney(
          variant.price,
          this.moneyFormat
        )}</span>`
      : `<span>${this.translations.only_poster}</span>`;
  }

  frameSelectHandlers(event) {
    const $msg = document.querySelector(
      ".sales-points span[data-product-inventory]"
    );
    const $icon = document.querySelector(
      ".sales-points .sales-point .icon-and-text"
    );
    const currentFrames = this.currentRammerSet();
    const selectedFrameVariant = event.target.value;
    const frameVariant = [...currentFrames].find(
      (frame) => frame.id == selectedFrameVariant
    );

    console.log("FrameSelectHandler:", { frameVariant, selectedFrameVariant });
    if (!frameVariant) {
      $icon?.classList.remove("inventory--low");
      $msg.textContent = this.translations.frame_in_stock;
      return;
    }

    const isSoldoutAndContinue =
      frameVariant.available && frameVariant.inventory_quantity < 1;

    if (frameVariant && isSoldoutAndContinue) {
      $icon.classList.add("inventory--low");
      $msg.textContent = this.translations.poster_no_frame;
    } else {
      $icon.classList.remove("inventory--low");
      $msg.textContent = this.translations.frame_in_stock;
    }
    // console.log('Frame select handlers changing', {
    //   el: $msg,
    //   translation: this.translations.poster_no_frame,
    // }, event.target, frameVariant, this.translations);
  }

  renderFrames() {
    const currentFrames = this.currentRammerSet();
    const $self = this;

    // console.log('renderFrames:', currentFrames);
    function renderItem(ramme) {
      const isSoldoutAndContinue =
        ramme.available && ramme.inventory_quantity < 1;

      return `
          <div>
            <input
              type="radio"
              name="radio-ramme"
              value="${ramme.id}" 
              form="${$self.el.dataset.formId}"
              ${!ramme.available ? "disabled" : ""}             
              id="${ramme.id}"
              class="imageRadio input-hidden screen-reader-text"
            >
            <label class="rammeContainer ${
              !ramme.available && !isSoldoutAndContinue ? "soldout-ramme" : ""
            }" for="${ramme.id}">
              <div class="rammeImgWrapper">
                <img class="ramme" src="${ramme.product_featured_image}" alt="${
        ramme.name
      }" />
              </div>  
              ${
                ramme.available
                  ? ""
                  : ` <span class="soldoutLabel" style="display: none">{{ 'products.product.frame_sold_out' | t }}</span> `
              }
              <span class="rammeInfo" style="display: none;">
                ${ramme.name.split("-")[0]} </br>
                <span class="rammePrice product__price bf">+${theme.Currency.formatMoney(
                  ramme.price
                )}</span>
              </span>
            </label>
          </div>
        `;
    }

    const html = [
      this.renderOnlyPoster(),
      ...currentFrames.map(renderItem),
    ].join("");

    console.log("RenderFrames:", { currentFrames });

    this.$container.innerHTML = html;
    this.$container
      .querySelectorAll('input[ name="radio-ramme"]')
      .forEach(($radio) => {
        $radio.addEventListener("change", this.frameSelectHandlers);
      });
    this.updateSelection();
  }

  renderOnlyPoster() {
    return `
      <div>
        <input
          type="radio"
          name="radio-ramme"
          checked
          value="noRamme"
              form="${this.el.dataset.formId}"
          id="noRamme"
          class="imageRadio input-hidden screen-reader-text"
        >
        <label class="rammeContainer" for="noRamme">
          <img class="ramme" src="${this.assets.only_poster}" alt="Kun plakat" />
          <span class="rammeInfo" style="display: none;">
            ${this.translations.only_poster} </br>
            <span class="rammePrice product__price bf" style="visibility: hidden">+0 kr</span>
          </span>
        </label>
      </div>
      `;
  }
}

customElements.define("rammer-options", RammerOptions);
